$shm_agent_message_text $mol_text
	embeds_allowed true
	file_open*? null
	event *
		^
		click? <=> link_click? null
	Chart* $shm_agent_message_chart
		option <= chart_option* null
		height <= chart_height* 320
	Chart_invalid* $mol_view
		sub <= chart_invalid_rows* /
	Chart_error* $mol_view
		sub / <= chart_error* \
